/**
 * @internal
 */
export var Operator;
(function (Operator) {
    Operator["AND"] = "&&";
    Operator["OR"] = "||";
    Operator["NOT"] = "!";
    Operator["GT"] = ">";
    Operator["GE"] = ">=";
    Operator["LT"] = "<";
    Operator["LE"] = "<=";
    Operator["NE"] = "!=";
    Operator["EQ"] = "==";
})(Operator || (Operator = {}));
/**
 * Used to describe how Expressions are joined
 * @public
 */
export class Join {
    constructor(type) {
        this.$$operator = type;
    }
    static And() {
        return new Join(Operator.AND);
    }
    static Or() {
        return new Join(Operator.OR);
    }
    static Not() {
        return new Join(Operator.NOT);
    }
    static GreaterThan() {
        return new Join(Operator.GT);
    }
    static GreaterThanOrEqual() {
        return new Join(Operator.GE);
    }
    static LessThan() {
        return new Join(Operator.LT);
    }
    static LessThanOrEqual() {
        return new Join(Operator.LE);
    }
    static NotEqual() {
        return new Join(Operator.NE);
    }
    static Equal() {
        return new Join(Operator.EQ);
    }
    get operator() {
        return this.$$operator;
    }
}
